import { prefixerM } from './common'

export const ROUTE_MANTENIMIENTO_GESTION_ESTRATEGIA = prefixerM('gestion-estrategia')

export const ROUTE_MANTENIMIENTO_PROCESOS = prefixerM('procesos')

export const ROUTE_MANTENIMIENTO_GESTION_AREAS_MANPROG = prefixerM('gestionAreas')

export const ROUTE_MANTENIMIENTO_GESTION_MAQUINARIA = prefixerM('crearMaquinaria')

export const ROUTE_MANTENIMIENTO_GESTION_MODELO = prefixerM('gestion-modelo')

export const ROUTE_MANTENIMIENTO_GESTION_PLAN_MANTENIMIENTO = prefixerM('gestion-plan-mantenimiento')
